/* eslint-disable camelcase */
import axios from '@axios'
export const state = {
  senders: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 1,
}

export const getters = {
  allSenders: (state) => state.senders,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_SENDERS: (state, data) => {
    if (!data) return false

    let { senders, page, perPage, totalRecords, totalPages } = data
    state.senders = senders
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
  },
  CREATE_SENDER: (state, sender) => {
    state.senders.unshift(sender)
  },
  APPROVE_SENDER: (state, sender) => {
    for (let i = 0; i < state.senders.length; i++) {
      if (state.senders[i].id === sender.id) {
        state.senders[i].status = sender.status
      }
    }
  },
  REJECT_SENDER: (state, sender) => {
    for (let i = 0; i < state.senders.length; i++) {
      if (state.senders[i].id === sender.id) {
        state.senders[i].status = sender.status
      }
    }
  },
  REMOVE_SENDER: (state, sender) => {
    state.senders = state.senders.filter((s) => s.id !== sender.id)
  },
  UPDATE_SENDER: (state, sender) => {
    for (let i = 0; i < state.senders.length; i++) {
      if (state.senders[i].id === sender.id) {
        for (let field in sender) {
          state.senders[i][field] = sender[field]
        }
        break
      }
    }
  },
  DEFAULT_SENDER: (state, sender) => {
    for (let i = 0; i < state.senders.length; i++) {
      state.senders[i].isDefault = false
      if (state.senders[i].id === sender.id) {
        state.senders[i].isDefault = sender.isDefault
      }
    }
  },
}

export const actions = {
  async getSenders({ commit }, params = {}) {
    let { _commit } = params
    if (typeof (_commit) === 'boolean' && _commit === false) return axios.get('/sms/senders', { params: params })
    await axios.get('/sms/senders', { params: params }).then(resp => {
      if (resp.status === 200) {
        commit("GET_SENDERS", resp.data)
      }
    })
  },
  async getSendersAxios({ commit }, params = {}) {
    return axios.get('/sms/senders', { params: params })
  },
  async createSender({ commit }, sender) {
    await axios.post('/sms/senders', sender).then((resp) => {
      if (resp.status === 201) {
        let sender = resp.data
        commit('CREATE_SENDER', sender)
      }
    })
  },
  async approveSender({ commit }, sender) {
    await axios
      .patch(`/sms/senders/${sender.id}/status`, sender)
      .then((resp) => {
        if (resp.status === 200) {
          let sender = resp.data
          commit('APPROVE_SENDER', sender)
        }
      })
  },
  async rejectSender({ commit }, sender) {
    await axios
      .patch(`/sms/senders/${sender.id}/reject`, sender)
      .then((resp) => {
        if (resp.status === 200) {
          let sender = resp.data
          commit('REJECT_SENDER', sender)
        }
      })
  },
  async removeSender({ commit }, sender) {
    await axios.delete(`/sms/senders/${sender.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_SENDER', sender)
      }
    })
  },
  async updateSender({ commit }, sender) {
    await axios.put(`/sms/senders`, sender).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_SENDER', resp.data)
      }
    })
  },

  async setDefaultSender({ commit, dispatch }, sender) {
    if (sender.status !== 'approved') {
      let notification = {
        id: Date.now(),
        message: 'Cannot set sender as default.',
        type: 'error',
        title: 'Set default',
      }
      dispatch('notification/addNotification', notification, { root: true })
      return true
    }
    await axios.patch(`/sms/senders/${sender.id}/default`).then((resp) => {
      if (resp.status === 200) {
        let sender = resp.data
        commit('DEFAULT_SENDER', sender)
      }
    })
  },
}
